module.exports = __webpack_public_path__ + "static/img/item8.6dd920f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/item8.png
// module id = h8y0
// module chunks = 0